import { actions } from './specialty/actions'
import { getters } from './specialty/getters'
import { state } from './specialty/state'
import { mutations } from './specialty/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
